<template>
    <div class="m-portlet  m-portlet--head-sm  m-b-20" v-loading=$parentInfo.studentPeriod.loading v-if="isMounted"
         :style="{'height': 340-$parentInfo.heightChange+'px'}">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <div class="el-icon-refresh" style="position: absolute;left: 10px;top: 20px;" @click="refreshStudentPeriod">
                    </div>
                    <h3 class="m-portlet__head-text">
                        在读课程概况
                    </h3>
                    <div style="position: absolute;left: 130px;top: 18px;">
                        <el-popover
                                placement="right"
                                trigger="click">
                            <img src="@/assets/img/periods/period.png">
                            <div slot="reference" class="el-icon-question"></div>
                        </el-popover>
                    </div>
                </div>
            </div>
            <div class="m-portlet__head-tools">
                <ul class="m-portlet__nav">
                    <li class="m-portlet__nav-item" v-for="item in $parentInfo.studentPeriod.studentPeriodStyles"
                        :key="item.id">
                        <div class="m-portlet__nav-link m-portlet__nav-link--icon text-black-50">
                            <div :style="{'background': item.color}"
                                 style="float:left;width: 15px;height: 15px;border-radius: 50%"></div>
                            <div style="float:left;font-size: 12px;margin:0 5px">{{item.remark}}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <vue-scroll :ops="$ops" :style="{'height': 280-$parentInfo.heightChange+'px'}">
            <div class="m-portlet__body">
                <div v-for="(courses,index0) in $parentInfo.studentPeriod.studentActivePeriods" :key="index0">
                    <div v-for="(course,index) in courses" :key="index">
                        <h6 class="m-b-10">
                            <el-row :gutter="20">
                                <el-col :span="6"> ({{course.semester_name}})-{{course.class_name}}</el-col>
                                <el-col :span="6">任课老师：{{course.teacher_name}}</el-col>
                                <el-col :span="6">时间段：{{course.time}}</el-col>
                            </el-row>
                        </h6>
                        <div style="position: relative;height: 30px;">
                            <div v-for="(class_plan_items,index1) in course.class_plan_item_arr" :key="index1">
                                <div v-for="(plan,index2) in class_plan_items"
                                     style="position:absolute;top:0;z-index: 10"
                                     :style="{'left':index1*50+index2*10+ 'px'}"
                                     :key="index2" @show="handleShowPeriod(plan.id,plan.status)">
                                    <el-popover
                                            placement="bottom"
                                            title="详情"
                                            width="400"
                                            v-model="plan.showPopper"
                                            trigger="click"
                                            :disabled="!$parentInfo.studentPeriod.showPopover">
                                        <div v-if="clickPlanId==plan.id">
                                            <ActivePeriod
                                                    v-if="plan.status === 'active' || plan.status === '' || plan.status === null || plan.status === 'truancy'"
                                                    :classPlanStudent_id="plan.id"
                                                    :class_name="course.class_name"
                                                    :student_id="$parentInfo.student_id"
                                                    :status_type="plan.status_type"
                                                    @hideModel="plan.showPopper=false"></ActivePeriod>
                                            <AbsentPeriod v-if="plan.status === 'absent'"
                                                          :classPlanStudent_id="plan.id"
                                                          :student_id="$parentInfo.student_id"
                                                          @hideModel="plan.showPopper=false"></AbsentPeriod>
                                            <FinishedPeriod v-if="plan.status === 'finished'"
                                                            :classPlanStudent_id="plan.id"
                                                            @hideModel="plan.showPopper=false"></FinishedPeriod>
                                            <SwitchingPeriod
                                                    v-if="plan.status === 'switching' ||  plan.status ==='tutorship'"
                                                    :classPlanStudent_id="plan.id"
                                                    @hideModel="plan.showPopper=false"></SwitchingPeriod>
                                            <LeavingPeriod
                                                    v-if="plan.status === 'leaving' ||  plan.status ==='orgReason'"
                                                    :classPlanStudent_id="plan.id"
                                                    :classPlanStudent_status="plan.status"
                                                    :class_name="course.class_name"
                                                    :student_id="$parentInfo.student_id"
                                                    :status_type="plan.status_type"
                                                    @hideModel="plan.showPopper=false"></LeavingPeriod>
                                            <AskForLeave
                                                    v-if="plan.status === 'applyForLeave'"
                                                    :classPlan_id="plan.classPlan_id"
                                                    :student_id="$parentInfo.student_id"
                                                    :classPlanStudent_status="plan.status"
                                                    :classPlanStudent_id="plan.id"
                                                    :status_type="plan.status_type"
                                                    @hideModel="plan.showPopper=false"></AskForLeave>
                                            <AskForRefund
                                                    v-if="plan.status === 'applyForRefund'"
                                                    :classPlan_id="plan.classPlan_id"
                                                    :student_id="$parentInfo.student_id"
                                                    :classPlanStudent_status="plan.status"
                                                    :classPlanStudent_id="plan.id"
                                                    :status_type="plan.status_type"
                                                    @hideModel="plan.showPopper=false"></AskForRefund>
                                        </div>
                                        <div slot="reference"
                                             style="width: 20px;height:20px;border-radius: 50%;box-shadow: 0 0 1px 1px rgba(22,25,49,0.5);text-align: center"
                                             :style="{'background':plan.color}" :title="plan.date"
                                            @click="handleClickCircle(plan.id,plan.status,plan.student_id,plan.status_type)">
                                            <span v-if="plan.status === 'applyForLeave'||plan.status === 'applyForRefund'">申</span>
                                            <span v-else-if="plan.status === 'active'&& plan.status_type === 0">调</span>
                                            <span v-else-if="plan.status === 'leaving'&& plan.status_type === 1">Ⅰ</span>
                                            <span v-else-if="plan.status === 'leaving'&& plan.status_type === 2">Ⅱ</span>
                                            <span v-else-if="plan.status === 'leaving'&& plan.status_type === 3">Ⅲ</span>
                                            <span v-else-if="plan.status === 'leaving'&& plan.status_type === 4">Ⅳ</span>
                                        </div>
                                    </el-popover>
                                </div>

                            </div>
                            <div style="width: 1000px;border-bottom: 1px dashed rgba(22,25,49,0.5);position: absolute;top: 10px;z-index: 1;"></div>
                        </div>
                    </div>
                    <div class="m-separator m-separator--space m-separator--dashed" v-if="courses.length!=0"></div>
                    <div style="clear:both"></div>
                </div>
            </div>
        </vue-scroll>
    </div>
</template>

<script>
    import ActivePeriod from "../TimeTable/ActivePeriodModal"
    import AbsentPeriod from "../TimeTable/AbsentPeriodModal"
    import FinishedPeriod from "../TimeTable/FinishedPeriodModal"
    import SwitchingPeriod from "../TimeTable/SwitchingPeriodModal"
    import LeavingPeriod from "../TimeTable/LeavingPeriodModal"
    import AskForLeave from "../TimeTable/AskForLeave"
    import AskForRefund from "../TimeTable/AskForRefund"

    export default {
        data() {
            return {
                isMounted: false,
                clickPlanId:0,
            };
        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowPeriods();
            this.handleGetClassPlanStatus();
            this.isMounted = true;
        },
        components: {
            ActivePeriod,
            AbsentPeriod,
            FinishedPeriod,
            SwitchingPeriod,
            LeavingPeriod,
            AskForRefund,
            AskForLeave,
        },
        created() {

        },
        methods: {
            handleClickCircle(classPlan_student_id,status,student_id,status_type){
                this.clickPlanId=classPlan_student_id;
                this.$parentInfo.studentPeriod.applyReasons.applyDetails=[];
                if(status=='finished'){
                    this.$wApi.send(this.$parentInfo.path, 'showFinishedPeriod', {
                        'classPlanStudent_id': classPlan_student_id,
                    });
                }
                else if(status=='applyForLeave' || status=='applyForRefund'
                    || status=='leaving'|| status=='refund'
                    || status=='refundAll'|| status=='switching'){
                    this.$wApi.send(this.$parentInfo.path, 'get_applyReason', {
                        'student_id': student_id,
                        'classPlan_student_id': classPlan_student_id,
                    });
                }
                else if(status=='active' || status=='absent'){
                    this.$parentInfo.studentPeriod.activePeriod.status = status;
                    if(status=='active'){
                        this.$parentInfo.studentPeriod.activePeriod.options=[];
                        if (status=='active' && status_type==0) {
                            this.$parentInfo.studentPeriod.activePeriod.status='active_type_1'
                            this.$parentInfo.studentPeriod.activePeriod.options.push({
                                value: 'switching',
                                label: '调课'
                            },{
                                value: 'tutorship',
                                label: '补课'
                            })
                        }
                        else{
                            this.$parentInfo.studentPeriod.activePeriod.options.push({
                                value: 'active',
                                label: '激活状态'
                            },{
                                value: 'orgReason',
                                label: '机构原因'
                            })
                        }
                        this.$parentInfo.studentPeriod.activePeriod.options.push({
                                value: 'refund',
                                label: '标准退费'
                            },
                            {
                                value: 'leaving',
                                label: '请假'
                            },
                            {
                                value: 'truancy',
                                label: '旷课'
                            },
                            {
                                value: 'active_type_1',
                                label: '调休调整'
                            });
                        if (this.status_type==0) {
                            this.$parentInfo.studentPeriod.activePeriod.options.push({
                                value: 'return',
                                label: '返回上一步'
                            })
                        }
                    }
                }
            },
            handleGetClassPlanStatus() {
                this.$wApi.send(this.$parentInfo.path, 'get_classPlanStatus');
            },
            handleShowPeriods() {
                this.$wApi.send(this.$parentInfo.path, 'studentPeriod', {
                    'student_id': this.$parentInfo.student_id,
                    'type': 'active',
                    'semester_id': 1,
                });
            },
            handleShowPeriod(classPlanStudent_id, status) {
                switch (status) {
                    case 'leaving':
                        if (status == 'orgReason') {
                            this.$parentInfo.studentPeriod.leavingPeriod.options.push({
                                value: 'refundAll',
                                label: '全额退费'
                            })
                        }
                        break;
                    case 'finished':
                        this.$parentInfo.studentPeriod.finishPeriod.loading = true;
                        for (let i = 0; i < this.$parentInfo.studentPeriod.finishPeriod.finishPeriod.length; i++) {
                            if (this.$parentInfo.studentPeriod.finishPeriod.finishPeriod[i].id != classPlanStudent_id) {
                                if (i == this.$parentInfo.studentPeriod.finishPeriod.finishPeriod.length - 1) {
                                    this.$parentInfo.studentPeriod.finishPeriod.classPlanStudent_id = classPlanStudent_id;
                                    this.$wApi.send(this.$parentInfo.path, 'showFinishedPeriod', {
                                        'classPlanStudent_id': classPlanStudent_id,
                                    });
                                }
                            } else {
                                this.$parentInfo.studentPeriod.finishPeriod.openFinishedPeriod = this.$parentInfo.studentPeriod.finishPeriod.finishPeriod[i];
                                this.$parentInfo.studentPeriod.finishPeriod.loading = false;
                                break;
                            }
                        }
                        break;
                    case 'switching':
                        this.$wApi.send(this.$parentInfo.path, 'switchingPeriod', {
                            'classPlanStudent_id': classPlanStudent_id,
                        });
                        break;
                }
            },
            refreshStudentPeriod(){
                this.$parentInfo.studentPeriod.loading=true;
                this.$wApi.send(this.$parentInfo.path, 'refreshStudentPeriod', {
                    'student_id': this.$parentInfo.student_id,
                    'type': 'active',
                    'semester_id': 1,
                });
            }
        }
    }
</script>

<style scoped>

</style>
